import axios from 'axios';
import { cmsUrl } from '../../variables';

export default {
    loadAllEvents(context) {
        axios
            .get(cmsUrl + '/current_events')
            .then(data => context.commit('loadAllEventsSuccess', data.data))
            .catch(err => context.commit('loadAllEventsError', err))
    },
    
};